import { Chip } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import { OrderStatus } from "@/graphql/codegen/graphql"
import { ORDER_STATUS_LABEL_LOOKUP } from "@/screens/Procurement/PurchaseOrders/constants"

interface ProductInventoryTransactionStatusChipProps {
  status?: OrderStatus | null
}

const STATUS_TO_CLASS_NAME: Partial<Record<OrderStatus, string>> = {
  [OrderStatus.Shipped]: "border-tertiary-purple-300",
  [OrderStatus.Received]: "border-tertiary-green-300",
} as const

export const ProductInventoryTransactionStatusChip: FC<ProductInventoryTransactionStatusChipProps> = ({ status }) => {
  if (!status) return null

  return (
    <Chip
      variant='outlined'
      className={twMerge("h-6 text-xs", STATUS_TO_CLASS_NAME[status] ?? "border-gray-500")}
      label={ORDER_STATUS_LABEL_LOOKUP[status]}
    />
  )
}
